/*=========================================================================================
  File Name: moduleCustomerMutations.js
  Description: Customer Module Mutations
==========================================================================================*/

export default {
	SET_CUSTOMERS_SEARCH_QUERY(state, query) {
		state.customersSearchQuery = query;
	},
	UPDATE_CUSTOMERS_FILTER(state, filter) {
		state.customersFilter = filter;
	},

	// API
	SET_CUSTOMERS(state, customers) {
		state.customers = customers;
	},

	ADD_CUSTOMER(state, customer) {
		state.customers.unshift(customer);
	},

	UPDATE_CUSTOMER(state, customer) {
		const customerIndex = state.customers.findIndex(t => t.id === customer.id);
		Object.assign(state.customers[customerIndex], customer);
	},

	DELETE_CUSTOMER(state, customerId) {
		const customerIndex = state.customers.findIndex(t => t.id == customerId);
		state.customers.splice(customerIndex, 1);
	},
	SET_TOTAL_CUSTOMERS(state, total) {
		state.total = total;
	},
	ADD_CUSTOMER_DEBT(state, debt) {
		state.debts.push(debt);
	},
	SET_CUSTOMER_DEBTS(state, debts) {
		state.debts = debts;
	},
	SET_TOTAL_CUSTOMER_DEBTS(state, total) {
		state.debtsTotal = total;
	},
	SET_SHOW_PRODUCTS(state, products) {
		state.showProducts = products;
	},
	INCREASE_TOTAL_DEBTS(state) {
		state.debtsTotal = state.debtsTotal + 1;
	},
	SET_CUSTOMER_DEBTS_REPORT_EXCEL(state, report) {
		state.debtsReportExcel = report;
	},
	UPDATE_CUSTOMER_ACCCESSABLE_FIELDS(state, fields) {
		state.acccessableFields = fields;
	},
	SET_PIPELINES(state, pipelines) {
		state.pipelines = pipelines;
	},
	ADD_PIPELINE(state, pipeline) {
		state.pipelines = [...state.pipelines, pipeline];
	},
	UPDATE_PIPELINE(state, pipeline) {
		const idx = state.pipelines.findIndex(t => t.id === pipeline.id);
		Object.assign(state.pipelines[idx], pipeline);
	},
	DELETE_PIPELINE(state, id) {
		const idx = state.pipelines.findIndex(t => t.id == id);
		state.pipelines.splice(idx, 1);
	},
	SORT_PIPELINE() {},
	SET_TOTAL_SHOW_PRODUCTS(state, total) {
		state.totalShowProducts = total;
	},
	ADD_PRODUCT(state, product) {
		state.showProducts = [...state.showProducts, product];
		state.totalShowProducts = state.totalShowProducts + 1;
	},
	UPDATE_PRODUCT(state, product) {
		const idx = state.showProducts.findIndex(t => t.id === product.id);
		Object.assign(state.showProducts[idx], product);
	},
	DELETE_PRODUCT(state, id) {
		const idx = state.showProducts.findIndex(t => t.id == id);
		state.showProducts.splice(idx, 1);
		state.totalShowProducts = state.totalShowProducts - 1;
	}
};
